import { openAppointmentModal } from './modal-appointment-courses';

const heroOpenModal = document.getElementById('hero-btn-modal');

heroOpenModal.addEventListener('click', openAppointmentModal);
